import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="pt-32 min-h-[70vh] flex items-center justify-center" data-testid="payment-cancel-page">
      <div className="max-w-xl mx-auto px-6 text-center">
        <p className="text-[12px] uppercase tracking-editorial text-plum mb-4">Payment Cancelled</p>
        <h1 className="font-serif text-5xl font-light mb-6">No worries.</h1>
        <p className="text-matte/60 leading-relaxed mb-10">
          Your payment was cancelled and nothing was charged. Your selection is still waiting for you.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/cart" className="border border-matte px-8 py-4 text-[12px] uppercase tracking-editorial hover:bg-matte hover:text-ivory transition-colors">Return to Cart</Link>
          <Link to="/shop" className="px-8 py-4 text-[12px] uppercase tracking-editorial text-matte/60 hover:text-matte transition-colors">Keep Browsing</Link>
        </div>
      </div>
    </div>
  );
}
